var Handlebars = require("/Users/dilip/projects/all/comeon-mobile/comeon-mobile-view/src/main/app/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(require("/Users/dilip/projects/all/comeon-mobile/comeon-mobile-view/src/main/app/packages/mobile-core/src/templates/explore-game-small.handlebars"),depth0,{"name":"explore-game-small","data":data,"indent":"    ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.blockHelperMissing.call(depth0,container.lambda(((stack1 = (depth0 != null ? depth0.gameData : depth0)) != null ? stack1.all : stack1), depth0),{"name":"gameData.all","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true});


//////////////////
// WEBPACK FOOTER
// ./mobile-core/src/templates/games.handlebars
// module id = 565
// module chunks = 0